export const en_us = {
  SIGNUPTEXT: "Sign Up For Proposition 65 Warnings Activated by the SoCalGas Aliso Canyon Fence-Line Monitoring System",
  CLICK_APPR_TEXT: "Click on the Appropriate Button Below to Get Warnings by Email or Text Message.",
  VIEW_ALERT_HISTORY: "View Alert History",
  EMAIL: "Email",
  TEXT_MESSAGE: "Text Message",
  OPERATED_BY: "Operated by",
  SOCALGAS_OPPORTUNITY_TEXT: 'SoCalGas is providing the opportunity to receive an email or text message with a warning \
    when the fence-line monitoring system at the Aliso Canyon Gas Storage Facility detects methane \
    in the air in excess of 25 parts per million for 30 minutes, \
    followed by a detection of benzene at a level of 1.5 parts per billion or greater averaged over any 30-minute period.',
  SOCALGAS_OPPORTUNITY_TEXT_P2: 'The warning does not necessarily mean that you have been exposed to benzene from the facility.\
  Distance from the facility, wind direction, meteorological conditions, and topography\
  all play a part in whether there would be concentrations of benzene high enough to cause an exposure at a specific location.\
  If a warning notification is issued, you are encouraged to check the <a target=\'_blank\' href=\'../warnings\'}>alisocynalerts.sonomatechdata.com/warnings</a> for more information on the nature and timing of the exceedance.\
  These warning notifications are provided pursuant to California’s Proposition 65\
  and are similar to warning notifications you may be familiar with at gas stations,\
  parking garages, and other locations. For questions about California’s Proposition 65,\
  please visit <a target=\'_blank\' href=\'https://www.p65warnings.ca.gov/\'}>p65warnings.ca.gov.</a>',
  SOCALGAS_AUTHORIZED_CONTRACTOR: 'Sonoma Technology is a SoCalGas authorized contractor responsible for administering the website, text, and email warnings for this program.',
  REFERENCES_HEREBY: 'Reference herein to any specific information regarding Southern California Gas Company (SoCalGas®) or any commercial products or services by trade name, \
    trademark, manufacturer or otherwise, does not constitute or imply its endorsement, recommendation, or favoring by SoCalGas. SoCalGas will not be held liable \
    in connection with any of Sonoma Technology’s activities.',
  REFERENCES_HEREBY_P2: 'Without limiting the generality of the foregoing, SoCalGas does not represent or warrant the \
  accuracy or reliability of any of the information, content or advertisements contained on, distributed through, or linked, downloaded or accessed from this\
   website other than the information contained on each of their respective websites.',
  SOCALGAS_TERMSCONDITION_POLICY: 'While this website is operated by Sonoma Technology, we follow the <a href=\'https://www.socalgas.com/terms-and-conditions\' target=\'_blank\'>Terms & Conditions</a> and <a href=\'https://www.socalgas.com/privacy-center\' target=\'_blank\'>Privacy Policy</a> of SoCalGas.\
     For the Terms & Conditions and Privacy Policy that govern this website, please visit the SoCalGas website at <a target=\'_blank\' href=\'https://www.socalgas.com\'>www.socalgas.com</a>.',
  TRADEMARK_STATEMENT: '©2022 Sonoma Technology. The trademarks used herein are the property of their respective owners. All rights reserved. \
     Some materials used under license, with all rights reserved by licensor.',
  SUBSCRIBE_EMAIL: 'Sign Up for Prop. 65 Warnings (Email)',
  SUBSCRIBE_TX_NOTIFS: 'Sign Up for Prop. 65 Warnings (Text Message)',
  EMAIL_NOTIFS: 'Email notifications',
  ENTER_NAME: 'Enter your name (optional)',
  ENTER_EMAIL: 'Enter a valid email address',
  CONFIRM_EMAIL: 'We need to confirm your email address.',
  CONFIRMATIN_LINK_MESSAGE: 'To complete the subscription process, please click the link in the email we just sent you.\
    If it doesn’t show up in a few minutes, check your spam folder.',
  CANCEL: 'Cancel',
  SUBSCRIBE: 'Subscribe',
  PLS_ENTR_TO_RECV_TXT: 'Please enter a valid 10-digit U.S. mobile phone number.',
  PLS_ENTER_VALID_10NUM: 'Please enter a valid 10-digit U.S. mobile phone number',
  PLS_ENTER_VALID_EMAIL: 'Please enter a valid email',
  SUBSCRIBED: 'Subscribed!',
  EMAIL_SUBSCRIBERS: 'Email Subscribers',
  SMS_SUBSCRIBERS: 'SMS Subscribers',
  Notification_Time: 'Notification Time',
  EMAIL_CONTENT: 'Email Content',
  SMS_CONTENT: 'SMS Content',
  VIEW: 'View',
  ALERTS_HISTORY: 'Alerts History',
  ALERTS: 'Alerts',
  CONTENT: 'Content',
  VIEW_HISTORICAL_WARNINGS: 'View Last 90 Days of Warnings',
  ISSUED_WARNINGS: 'Warnings',
  NO_WARNINGS_ISSUED_IN_90_DAYS: 'No warnings have been issued',
  VIEW_WARNINGS_DESCRIPTION: 'View the History of Benzene Exceedance Warnings Issued in the Past 90 Days.',
  WEBSITE_WARNING_EXCEEDENCE_START: 'On [STARTDATE] at [STARTTIME], fence-line monitors detected an exceedance of a warning threshold for benzene established by\
     a consent judgment entered by the Los Angeles Superior Court. Benzene is known to the State of California to cause cancer and birth defects and other\
     reproductive harm.',
  WEBSITE_WARNING_EXCEEDENCE_END: 'On [STARTDATE] at [STARTTIME], fence-line monitors detected an exceedance of a warning threshold for benzene established by a\
      consent judgment entered by the Los Angeles Superior Court. The Incident as defined by the consent judgment associated with this warning terminated \
      before or on [ENDDATE] at [ENDTIME]. Benzene is known to the State of \
      California to cause cancer and birth defects and other reproductive harm.',
  FOR_MORE_INFO_GO_TO: 'For more information go to',
  HOME: 'Home',
  LOADING_ALERTS: 'Loading alerts.....',
  ADMIN: 'Admin',
  SIGN_UP_FOR_PROP66_WARNINGS: 'Sign Up for Proposition 65 Warnings',
  LANGUAGE: 'Language',
  ENGLISH: 'English',
  SPANISH: 'Spanish',
  HEADER_TITLE: 'Aliso Canyon Benzene Monitoring Warning Subscription System',
  PERSONAL_INFORMATION_DISCLOSURE: "Your contact information will only be used to notify you about Proposition 65 Warnings activated by the SoCalGas Aliso Canyon Fence-line monitoring system. SoCalGas and Sonoma Technology do not share this information with third parties. ",
  NAME: "Name",
  PHONE_NUMBER: "Phone Number",
  HISTORICAL_WARNINGS: "Last 90 Days of Warnings",
  UNABLE_TO_DISPLAY_INFORMATION_AT_THIS_TIME: 'Unable to display information at this time.',
  PROP_66_WARNING: "PROPOSITION 65 WARNING",
  ACTIVE_EVENT: "Active Event",
  EVENT_ENDED: "Event Ended",
  ALISO_CANYON_PROP65_WARNING: "Aliso Canyon Prop 65 Warning System",
  SUBSC_PREF: "Subscription Preferences",
  EMAIL_ADDR: "Email address:",
  OPT_OUT_MESG: "To opt out, uncheck the box below and save your preferences.",
  PROP_65_WARNING_2: 'Proposition 65 Warnings',
  ACTIVATEDBY: "Activated by the Aliso Canyon Fence-Line Monitoring System",
  UPDATE_YR_SUB: "You can update your subscription preferences at any time by clicking the link in the footer of any email you receive from us.",
  PREF_SAVED: "Preferences saved! You are now opted ",
  UNEXPECTED_ERROR: "An unexpected error occurred.",
  INVALID_REQUEST: "Invalid request",
  SAVE_PREFERENCES: "Save Preferences",
}